"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleContainer = exports.Root = exports.IntroContainer = exports.ImageSkeleton = exports.CategorySkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../ArticleBox/constants");
var _styles = require("../styles");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: _constants.ARTICLE_BOX_MOBILE_WIDTH,
  [theme.breakpoints.up('sm')]: {
    maxWidth: _constants.ARTICLE_BOX_DESKTOP_WIDTH
  }
}));
const ImageSkeleton = exports.ImageSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)(({
  theme
}) => ({
  width: '100%',
  height: 170,
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(3),
  maxWidth: _constants.ARTICLE_BOX_MOBILE_WIDTH,
  [theme.breakpoints.up('sm')]: {
    maxWidth: _constants.ARTICLE_BOX_DESKTOP_WIDTH
  }
}));
const CategorySkeleton = exports.CategorySkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)(({
  theme
}) => ({
  width: 50,
  height: '1.6rem',
  marginBottom: theme.spacing(2)
}));
const TitleContainer = exports.TitleContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(1.4),
  marginTop: theme.spacing(0.4)
}));
const IntroContainer = exports.IntroContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginTop: theme.spacing(0.4),
  marginBottom: theme.spacing(2.4)
}));
